import RegMark from './RegMark'
import { IsofixGlyph } from './Artwork'
import { IconArrowRight } from './Icon'
import './transfer-strip.css'

const LINE = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 3.6,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
}

/**
 * One mark through one pad-print transfer, in three panels: the artwork on the
 * cliché film (blue line), the ink on the silicone pad (reversed) and the mark
 * printed white on the moulded part. Labels are the print-process station names.
 * Decorative: the article carries the explanation.
 *
 * @param {{ labels: [string, string, string] }} props
 */
export default function TransferStrip({ labels }) {
    const panels = [
        { key: 'film', mirrored: false },
        { key: 'pad', mirrored: true },
        { key: 'part', mirrored: false },
    ]
    return (
        <div className="transfer-strip plate--marks" aria-hidden="true">
            {panels.map((panel, i) => (
                <div className={`transfer-panel transfer-panel--${panel.key}`} key={panel.key}>
                    <svg viewBox="-50 -50 100 100" className="transfer-mark" focusable="false">
                        <g {...LINE}>
                            <IsofixGlyph mirrored={panel.mirrored} />
                        </g>
                    </svg>
                    <span className="transfer-label legend">
                        <RegMark size={14} />
                        {labels[i]}
                    </span>
                    {i < panels.length - 1 ? <IconArrowRight className="transfer-arrow" size={22} /> : null}
                </div>
            ))}
        </div>
    )
}
